

















































































































import AbpBase from '../../../lib/abpbase'
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import {CreatePharmacyStockIn,
        QuerySupplier,
        QueryPharmacyStockIn,
        QueryPharmacyStockInDetailById,
        EditPharmacyStockInCheck,
        EditPharmacyStockInCharge,
        EditDelPharmacyStockIn,
        QueryPharmacyStandingBookBatchNum 
} from '../../../api/pharmacy'
import {QueryDrug} from '../../../api/specialDictionary'
import {GetMeteringList} from '../../../api/basicDictionary'
import Util from '../../../lib/util'
import u from 'underscore'
//单据打印组件
import print from '../../../components/print/stockBills.vue'

@Component({
    components:{print}
})
export default class StorageIn extends AbpBase {
    
    printShow:Boolean = false;
    printData = {
        list:[],
        title:[
            '单据编码',
            '药品名称',
            '生产厂家',
            '数量',
            '单位',
            '进价',
            '进价总额',
            '零价',
            '零价总额',
            '批号',
            '有效日期',
            '入库人',
            '入库日期',
        ]
    }

    list = []//table数据源
    tabList:any = []//选择table数据源
	
	table = {
		loading:false,
		tabLoading:false,
    }
     //远程搜索加载
    remoteloading:Boolean = true;
    //点击选择or不选中
    flag:Boolean = true;
    
    //按钮装态
    deleteBillsShow:Boolean = false
    ztShow:Boolean = false
    checkShow:Boolean = true
    saveShow:Boolean = true

    //当前选择行状态 （暂存可新增，核对不可）
    rowStatus:Boolean = false;
    //核对loding
    checkLoding:Boolean = false;
    //暂存loding
    tsLoding:Boolean = false;
    //记账loding
    saveLoding:Boolean = false;
    //删除loding
    deleteLoding:Boolean = false;

    receiptNo:Number = Date.now();
    //数值累计判断
    reducePrice:Boolean = false;
    //当前选择行
    rowActive:any = {}

    model = {
        drugId:null,
        validityPeriod:null,
        quantity:null,
        unit:null,
        batchNo:null,
        purchasePrice:null,
        zeroPrice:null,
        supplierId:null,
    }

    created() {
        // this.getDrugList();
        // this.getMeteringList();
        this.querySupplier();
        this.getTabList()
    }
    //选择框数据
    unitOptions=[]
    drugOptions=[]
    drugList=[]
    supplierOptions=[]
    //获取tab 数据
    getTabList(){
        this.queryPharmacyStockIn()
    }
    async queryPharmacyStockIn(){
        this.table.tabLoading = true
		let payload = {
			pageSize:100,
			Page:1
		}
        let response = await QueryPharmacyStockIn(payload)
		this.tabList = response.data.items
        this.table.tabLoading = false
        //默认选择第一条
        if(this.tabList.length>0) {
            this.tabList[0]._highlight = true;
            this.rowActive = this.tabList[0];
            this.deleteBillsShow = false
            this.getStatus(this.tabList[0].stockInStatus)
            this.getTalDetail(this.tabList[0].id)
            //单据号
            this.receiptNo = Number(this.tabList[0].receiptNo)
            //带出供货商
            this.model.supplierId = this.tabList[0].supplierId
            
        }else{
            this.rowActive = ''
            this.ztShow = false
            this.checkShow = true
            this.saveShow = true
            this.rowStatus = false
            this.deleteBillsShow = true
        }
    }
    getStatus(type){
        //按钮status
        if(type == 1){
            this.ztShow = false
            this.checkShow = false
            this.saveShow = true
            this.rowStatus = false
            this.deleteBillsShow = false

        }else{
            this.ztShow = true
            this.checkShow = true
            this.saveShow = false
            this.deleteBillsShow = false
            this.rowStatus = true
        }
        
    }
    //获取详情数据
    async getTalDetail(id){
         let data = {
            stockInId:id,
            pageSize:100,
            page:1
        }
        let res  = await QueryPharmacyStockInDetailById(data)
        this.list = res.data.pharmacyStockInDetailResult.items
        this.reducePrice = true;
        this.list.push({
            zj:true,
            receiptNo:'总价',
            batchPurchasePrice:res.data.sumPurchasePrice,
            batchZeroPrice:res.data.sumZeroPrice,
        })

    }
    //选择药品信息
    drugActiveinfo:any = {};
    //表格高度
    get tableHeight(){
        return window.innerHeight-580
    }
    //登陆人
    get staffName(){
        return this.$store.state.session.user?this.$store.state.session.user.name:''
    }
    //药品
	async remoteMethodDrug(query){
        let str = (this.$refs['setSelect'] as any).$data.query;
        if (str) {
        //赋值为空
            (this.$refs['setSelect'] as any).query = ''
        }
        this.drugOptions = [];
		if (query !== '') {
			this.remoteloading = true;
            let data = {
                queryString:query,
                status:1,
                pageSize:1000,
                page:1
            }
            let res = await QueryDrug(data)
            this.drugList = res.data.items
            setTimeout(() => {
                this.remoteloading = false;
                const list = res.data.items.map(item => {
                    return {
                        drugName: item.drugName,
                        drugId: item.id
                    };
                });
                this.drugOptions = list
            }, 200);
           
        } else {
            this.drugOptions = [];
        }
	}
    //单位
    async GetDrugRateUnit(id){
        let res = await this.$store.dispatch({
            type:'dictionaries/GetDrugRateUnit',
            data:{DrugId:id}
        })
        res.data.forEach(item => {
            item.rateUnit = Number(item.rateUnit)
        });
        this.unitOptions = res.data
    }
    //供货商
    async querySupplier(){
        let data = {
            QueryString:'',
            PageSize:1000,
            Page:1
        }
        let res = await QuerySupplier(data)
        this.supplierOptions = res.data.items
    }
    //药品信息带出
    async drugChange(){
        if(this.model.drugId){
             //加载单位
            await this.GetDrugRateUnit(this.model.drugId)
            this.drugList.forEach(item=>{
                if(item.id==this.model.drugId){
                    this.drugActiveinfo = item;
                    this.model.unit = Number(item.packingUnit)
                    this.unitChange()
                }
            })
        }
    }
    //单位选择触发价格变动
    unitChange(){
        this.unitOptions.forEach(item=>{
            if(item.rateUnit==this.model.unit){
                this.model.purchasePrice = Number(item.price.toFixed(3))
                this.model.zeroPrice = Number(item.zeroPrice.toFixed(3))
            }
        })
    }
    //数据导出
    exportData(){
        (this.$refs.table as any).exportCsv({
            filename: 'The original data'
        })
    }
    //清除高亮项
    clearCurrentRow(callback){
        (this.$refs.tabTable as any).clearCurrentRow()
        //重新生成单据号
        this.receiptNo = Date.now()
        //供货商 置空
        this.model.supplierId = 0;
        this.rowActive = {};
        this.list = []
        this.ztShow = false
        this.checkShow = true
        this.saveShow = true
        this.deleteBillsShow = true
        this.rowStatus = false
        callback()
    }
    //点击清除高亮
    firstTabChage:Boolean = true //(默认加载第一条。取消选择不会触发tabChange事件。记录没触发tabChange之前的状态)
    clecarActive(row){
        let indexs;
        this.tabList.forEach((item,index) => {
            if(item.id == row.id){
                indexs = index;
            }
        });
        if(this.rowActive.id == row.id && this.firstTabChage){
            this.clearCurrentRow(function(){})
        }
        if(this.flag){
            // this.tabList[indexs]._highlight = true;
            this.flag = false
            // this.deleteBillsShow = false;
        }else{
            this.clearCurrentRow(function(){})
            this.flag = true
        }
    }
    //表格添加
    push(){
        let that = this;
        (this.$refs.ruleForm as any).validate(async (valid:boolean)=>{
            if(valid){
                //清空表格尾部
                if(this.reducePrice){
                    this.list.pop()
                }
                this.list.push({
                   receiptNo:this.receiptNo,
                   drugName:this.drugActiveinfo.drugName,
                   quantity:this.model.quantity,
                   unit:this.model.unit,
                   drugId:this.model.drugId,
                   unitName: u.find(that.unitOptions, function(value, key, list){return list[key].rateUnit == that.model.unit}).rateUnitName,
                   batchNo:this.model.batchNo,
                   purchasePrice:this.model.purchasePrice,
                   zeroPrice:this.model.zeroPrice,
                   batchPurchasePrice:Number((this.model.purchasePrice*this.model.quantity).toFixed(3)),
                   batchZeroPrice:Number((this.model.zeroPrice*this.model.quantity).toFixed(3)),
                   manufacturer:this.drugActiveinfo.manufacturer,
                   validityPeriod:Util.dateConversion(this.model.validityPeriod),
                   staffName:this.staffName,
                   now:Util.dateConversion(new Date())
                })
                let values1 = this.list.map(item => Number(item.batchPurchasePrice));
                let values2 = this.list.map(item => Number(item.batchZeroPrice));
                let batchPurchasePrice = u.reduce(values1, function(memo, num){ return memo + num; }, 0);
                let batchZeroPrice = u.reduce(values2, function(memo, num){ return memo + num; }, 0);
                //合计计算
                
                this.list.push({
                    zj:true,
                    receiptNo:'总价',
                    batchPurchasePrice:batchPurchasePrice,
                    batchZeroPrice:batchZeroPrice,
                })
                this.reducePrice = true;
                this.clear()
            }
        })
    }
    //暂存
    Ts(){
        if(this.list.length<1){
            this.$Message.info('请选择药品');
            return false
        }
        if(!this.model.supplierId){
            this.$Message.info('请选择供货商');
            return false
        }
        //去掉合计
        this.list.pop()
        let data = {
            receiptNo:this.receiptNo,
            stockInId:this.rowActive.id || 0,
            supplierId:this.model.supplierId,
            pharmacyStockInInputDetailDto:this.list,
        }
        this.createStockIn(data)
    }
    async createStockIn(data){
        this.tsLoding = true;
        let res = await CreatePharmacyStockIn(data)
        if(res.code==2000){
             
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()
        }else{
             
        }
        this.tsLoding = false;
    }
    //核对
    async check(){
        let data = {
            stockIn:[{stockInId:this.rowActive.id}]
        }
        this.checkLoding = true;

        let res = await EditPharmacyStockInCheck(data)
        if(res.code==2000){
             
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()

        }else{
              
        }
            this.checkLoding = false;

    }
    //记账
    async save(){
        let data = {
            stockIn:[{stockInId:this.rowActive.id}]
        }
        this.saveLoding = true;
        let res = await EditPharmacyStockInCharge(data)
        if(res.code==2000){

            this.printData.list = []
            this.list.forEach((item,index)=>{
                this.printData.list.push([
                    item.receiptNo,
                    item.drugName,
                    item.manufacturer,
                    item.quantity,
                    item.unitName,
                    item.purchasePrice,
                    item.batchPurchasePrice,
                    item.zeroPrice,
                    item.batchZeroPrice,
                    item.batchNo,
                    Util.formatTime(item.validityPeriod),
                    item.staffName,
                    index == this.list.length-1 ?'':Util.dateConversion(new Date()),
                ])
            })
            this.printShow = true

             
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()
            // document.getElementById('pr').click()
        }else{
             
        }
        this.saveLoding = false;

    }
    //打印完成回调
    printBack(){
        this.printShow = false;
    }
    //删除单据
    async deleteBills(){
        this.$Modal.confirm({
			title: '确认删除',
			content: '',
			onOk: () => {
                this.deleteLoding = true;
				let data = {
                    stockIn:[{stockInId:this.rowActive.id}]
                }
				this.deleteStockIn(data)
			},
			onCancel: () => {
				
			}
		})
       
        
    }
    async deleteStockIn(data){
        let res = await EditDelPharmacyStockIn(data)
        if(res.code==2000){
             
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()
            this.deleteLoding = false;
        }else{
             
            this.deleteLoding = false;
        }
    }
    clear(){
		(this.$refs.ruleForm as any).resetFields();
    }
    delete(index:number){
        this.list.splice(index, 1);
        if(this.list.length==1){
            this.list.splice(0, 1);
        }
    }
    //tab选择
    tabChange(currentRow:any,oldCurrentRow:any){
        // console.log(currentRow)
        this.firstTabChage = false;
        if(currentRow){
            //带出单据号
            this.receiptNo = Number(currentRow.receiptNo)
            //带出供货商
            this.model.supplierId = currentRow.supplierId
            this.rowActive = currentRow
            this.getStatus(currentRow.stockInStatus)
            this.getTalDetail(currentRow.id)
            if(currentRow != oldCurrentRow){
                this.flag = true
            }
        }
    }
    

	columns = [{
		title: '单据编码',
        key: 'receiptNo',
        width:160,
	},{
		title: "药品名称",
        key: 'drugName',
        width:130,
	},{
		title: "生产厂家",
		key: 'manufacturer',
        width:130,
	},{
		title: "数量",
		key: 'quantity',
        width:130,
	},{
		title: "单位",
		key: 'unitName',
        width:130,
	},{
		title: "进价",
		key: 'purchasePrice',
        width:130,
	},{
		title: "进价总额",
		key: 'batchPurchasePrice',
        width:130,
	},{
		title: "零价",
		key: 'zeroPrice',
        width:130,
	},{
		title: "零价总额",
		key: 'batchZeroPrice',
        width:130,
	},{
		title: "批号",
		key: 'batchNo',
        width:130,
	},{
		title: "有效日期",
		key: 'validityPeriod',
        width:130,
        render: (h: any, params: any) => {
            return h('span',Util.formatTime(params.row.validityPeriod))
        }
	},{
		title: "入库人",
		key: 'staffName',
        width:130,
	},{
		title: "入库日期",
		key: 'now',
        width:130,
        render: (h: any, params: any) => {
           if(params.row.now){
               return h('span',Util.formatTime(params.row.now))
           }else{
               return h('span',Util.formatTime(params.row.validityPeriod))
           }
        }
	},{title: this.L('Actions'),
        key: 'Actions',
        fixed: "right",
        width:80,
		render: (h: any, params: any) => {
			if(!params.row.zj){
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'error',
                            size: 'small'
                        },
                        on: {
                            click: () => {
                                this.delete(params.add)
                            }
                        }
                    }, this.L('Delete'))
                ])
            }
		}
    }]
    tabColumns=[{
		title: '单据编码',
        key: 'receiptNo',
	},{
		title: "入库日期",
        key: 'stockInDate',

	},{
		title: "操作员",
        key: 'staffName',
	},{
		title: "状态",
        key: 'stockInStatus',
        render:(h: any, params: any) => {
            return h('span',params.row.stockInStatus == 1?"暂存":"核对")
        }  
	}]
    rules={
        drugId:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        unit:[{required:true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        batchNo:[{required: true,message:this.L('FieldIsRequired'),trigger: 'blur'}],
        quantity:[{required: true,message:this.L('FieldIsRequired'),type:'number', trigger: 'blur'}],
        validityPeriod:[{required: true,message:this.L('FieldIsRequired'),type:'date',trigger: 'blur'}],
        purchasePrice:[ { required: true, message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        zeroPrice:[ { required: true, message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        // supplierId:[ { required: false, message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        receiptNo:[ { required: false, message:this.L('FieldIsRequired'),trigger: 'blur'}],

    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pharmacy/storageIn/index.vue